import * as React from 'react';
import styled from 'styled-components';
import i18n from './../../../../i18n';
import { SettingsRow } from './UserWrapper';
import GhostButton from './../../../../components/GhostButton';
import { connect } from 'react-redux';

const LanguageChanger = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px;
  z-index: 10;
`;

const UserLanguageChanger = ({visible, translator}) => {
    if(visible) {
        return (
            <SettingsRow>
                <p>{translator('Change language')}: &nbsp; </p>
                <LanguageChanger className="languageChanger">
                    <GhostButton
                        style={{
                            width: '30px',
                            height: '30px',
                            display: 'flex',
                            justifyContent: 'center',
                            padding: '0',
                            alignItems: 'center',
                            margin: '0 5px 0 0',
                        }}
                        active={i18n.language === 'pl'}
                        onClick={
                            () => {
                                localStorage.setItem('language', 'pl');
                                i18n.changeLanguage('pl');
                            }
                        }>
                        pl
                    </GhostButton>
                    <GhostButton
                        style={{
                            width: '30px',
                            height: '30px',
                            display: 'flex',
                            justifyContent: 'center',
                            padding: '0',
                            alignItems: 'center',
                        }}
                        active={i18n.language === 'en'}
                        onClick={
                            () => {
                                i18n.changeLanguage('en');
                                localStorage.setItem('language', 'en');
                            }
                        }>
                        en
                    </GhostButton>
                </LanguageChanger>
            </SettingsRow> 
        );
    }
    return false;
}

const mapStateToProps = (state: State) => ({
    visible: !state.domainProperties.get('oneLanguage'),
});
export default connect(mapStateToProps, null)(UserLanguageChanger);


// WEBPACK FOOTER //
// ./src/containers/content/grid/userWrapper/UserLanguageChanger.jsx